<template>
  <a-form-item
    v-if="data"
    :label="data.fieldname"
    class="editor"
  >
    <!-- bidirectional data binding（双向数据绑定） $xss(value)-->
    <a-spin
      :spinning="imageLoading"
      :tip="loadTip"
    >
      <div
        v-decorator="[`${data.fieldkey}`, {
          rules: [{
            required: data.isneeded === 1 ? true : false,
            message: editorOption.placeholder
          }],
          initialValue: value
        }]"
        class="wrap"
        @paste="handlePaste"
      >
        <quill-editor
          ref="myQuillEditor"
          v-model="value"
          :options="editorOption"
          :class="{'quill-editor-fullscreen': isFullScreen}"
          @blur="onEditorBlur($event)"
          @change="onEditorChange($event)"
        >
          <div
            :id="`toolbar-${data.fieldkey}`"
            slot="toolbar"
          >
            <span
              v-if="toolbarItems.indexOf('font') !== -1"
              class="ql-formats"
            >
              <select
                :title="fontTit"
                class="ql-font"
              >
                <option selected />
                <option value="serif" />
                <option value="monospace" />
              </select>

              <select
                v-if="toolbarItems.indexOf('size') !== -1"
                :title="fontsizeTit"
                class="ql-size"
              >
                <option value="small" />
                <option selected />
                <option value="large" />
                <option value="huge" />
              </select>
            </span>
            <span class="ql-formats">
              <button
                v-if="toolbarItems.indexOf('bold') !== -1"
                :title="boldTit"
                class="ql-bold"
              />
              <button
                v-if="toolbarItems.indexOf('italic') !== -1"
                :title="italicsTit"
                class="ql-italic"
              />
              <button
                v-if="toolbarItems.indexOf('underline') !== -1"
                :title="underlineTit"
                class="ql-underline"
              />
              <button
                v-if="toolbarItems.indexOf('strike') !== -1"
                :title="delLine"
                class="ql-strike"
              />
            </span>
            <span
              v-if="toolbarItems.indexOf('list') !== -1"
              class="ql-formats"
            >
              <button
                :title="orderListTit"
                class="ql-list"
                value="ordered"
              />
              <button
                :title="disorderTit"
                class="ql-list"
                value="bullet"
              />
            </span>
            <span
              v-if="toolbarItems.indexOf('indent') !== -1"
              class="ql-formats"
            >
              <button
                :title="indentTit"
                class="ql-indent"
                value="-1"
              />
              <button
                :title="reduceTit"
                class="ql-indent"
                value="+1"
              />
            </span>
            <span class="ql-formats">
              <select
                v-if="toolbarItems.indexOf('color') !== -1"
                :title="colorTit"
                class="ql-color"
              />
              <select
                v-if="toolbarItems.indexOf('background') !== -1"
                :title="bgTxt"
                class="ql-background"
              />
            </span>
            <span
              v-if="toolbarItems.indexOf('align') !== -1"
              class="ql-formats"
            >
              <select
                :title="alignMentTxt"
                class="ql-align"
              />
            </span>
            <span class="ql-formats">
              <button
                v-if="toolbarItems.indexOf('link') !== -1"
                :title="hyLink"
                class="ql-link"
              />
              <button
                v-if="toolbarItems.indexOf('image') !== -1"
                :title="picTip"
                class="ql-image"
              />
            </span>
            <span
              v-if="toolbarItems.indexOf('clean') !== -1"
              class="ql-formats"
            >
              <button
                :title="clearStyleTit"
                class="ql-clean"
              />
            </span>
            <span
              v-if="toolbarItems.indexOf('fullscreen') !== -1"
              class="ql-formats"
            >
              <button
                :title="!isFullScreen ? allScreen[0] : allScreen[1]"
                class="ql-fullscreen iconfont iconfull-screen"
                @click="customButtonClick"
              />
            </span>
          </div>
        </quill-editor>
        <a-upload
          ref="button"
          name="file"
          :headers="{ 'X-Requested-With': null }"
          :show-upload-list="false"
          :before-upload="beforeUpload"
          multiple
          accept="image/*"
          :action="action"
          :data="getOtherParams"
          class="hide"
          @change="uploadChangeHandle"
        />
      </div>
    </a-spin>
  </a-form-item>
  <!-- Or manually control the data synchronization（或手动控制数据流） -->
  <!-- <quill-editor
    :content="content"
    :options="editorOption"
    @change="onEditorChange($event)"
  /> -->
</template>

<script>
import axios from 'axios'
import { upyunUpload, apiDomain } from '@/lib/config'
import { uploadSignature, uploadConvert } from '@/services/index'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

const bindings = {
  custom: {
    key: 13,
    handler: function (range, context) {
      this.quill.insertText(range.index, '\n ')
      setTimeout(() => {
        let nowRange = this.quill.getSelection().index - 1
        this.quill.setSelection(nowRange)
      }, 0)
    }
  }
}

export default {
  components: {
    quillEditor
  },
  inject: {
    myForm: {
      default: () => { }
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    toolbarItems: {
      type: Array,
      default: () => {
        return ['font', 'size', 'bold', 'italic', 'underline', 'strike', 'list', 'indent', 'color', 'background', 'align', 'link', 'image', 'clean', 'fullscreen']
      }
    },
    height: {
      type: Number,
      default: 460
    }
  },
  data () {
    let vm = this
    return {
      value: '',
      newValue: '',
      others: {},
      action: upyunUpload,
      pasteFiles: [],
      imageLoading: false,
      isFullScreen: false,
      editorOption: {
        placeholder: this.$t('message["812"]'),
        modules: {
          // toolbar: `#toolbar-${this.data.fieldkey}`,
          keyboard: {
            bindings: bindings
          },
          toolbar: {
            container: `#toolbar-${this.data.fieldkey}`,
            handlers: {
              'image': function () {
                vm.$refs.button.$refs.uploadRef.$el.click()
              }
            }
          }
        }
      }
    }
  },
  computed: {
    editor () {
      return this.$refs.myQuillEditor && this.$refs.myQuillEditor.quill
    },
    bgTxt () {
      return this.$t('message["29"]')
    },
    hyLink () {
      return this.$t('message["102"]')
    },
    alignMentTxt () {
      return this.$t('message["256"]')
    },
    boldTit () {
      return this.$t('message["470"]')
    },
    reduceTit () {
      return this.$t('message["477"]')
    },
    clearStyleTit () {
      return this.$t('message["737"]')
    },
    allScreen () {
      return this.$t('message["913"]').split('|')
    },
    delLine () {
      return this.$t('message["977"]')
    },
    loadTip () {
      return this.$t('message["1225"]')
    },
    picTip () {
      return this.$t('message["1224"]')
    },
    disorderTit () {
      return this.$t('message["1284"]')
    },
    underlineTit () {
      return this.$t('message["1294"]')
    },
    italicsTit () {
      return this.$t('message["1340"]')
    },
    orderListTit () {
      return this.$t('message["1514"]')
    },
    fontsizeTit () {
      return this.$t('message["1656"]')
    },
    indentTit () {
      return this.$t('message["1560"]')
    },
    fontTit () {
      return this.$t('message["1658"]')
    },
    colorTit () {
      return this.$t('message["1659"]')
    }
  },
  watch: {
    data: {
      handler (newValue, oldValue) {
        const { fieldvalue = '' } = newValue || {}
        this.value = this.$filterXss.process(fieldvalue)
      },
      immediate: true
    }
  },
  mounted () {
    const { fieldvalue = '' } = this.data || {}
    this.value = this.$filterXss.process(fieldvalue)

    // 富文本失去焦点事件
    this.$bus.$on('myQuillEditorBlur', this.onEditorBlur)
  },
  beforeDestroy () {
    this.$bus.$off('myQuillEditorBlur')
  },
  methods: {
    // 自定义富文本全屏
    customButtonClick () {
      let $el = this.$refs.myQuillEditor.$el
      this.isFullScreen = !this.isFullScreen
      if (this.isFullScreen) {
        $el.style.position = 'fixed'
        $el.style.top = 0
        $el.style.left = 0
        $el.style.zIndex = 9999
        $el.style.width = '100vw'
        $el.style.height = '100vh'
        $el.style.background = '#fff'
        document.body.style.overflow = 'hidden'
      } else {
        $el.style.position = 'relative'
        $el.style.zIndex = 1
        $el.style.width = 'auto'
        $el.style.height = 'auto'
        document.body.style.overflow = 'auto'
      }
    },
    onEditorBlur (quill) {
      this.validateFields()
    },

    // 富文本内容更新
    onEditorChange ({ quill, html, text }) {
      // this.value = this.$xss(html)
      this.value = html
      this.$emit('change', this.value)
      this.validateFields()
    },

    // 校验富文本内容
    validateFields () {
      const obj = {
        [this.data.fieldkey]: this.value
      }
      if (this.myForm) {
        this.myForm.setFieldsValue(obj)
        this.myForm.validateFields([`${this.data.fieldkey}`], () => { })
      }
    },

    // 点击工具栏上传参数处理
    getOtherParams () {
      return this.others
    },

    // 点击工具栏上传
    beforeUpload (file) {
      const vm = this
      const { name: filename } = file
      const type = filename && filename.split('.')[1]

      if (file.type && file.type.indexOf('image') === -1) {
        this.$message.error(this.$t('message["1599"]'))
        return false
      }
      if (type === 'php') {
        this.$message.error(this.$t('message["1599"]'))
        return false
      }

      this.imageLoading = true

      return new Promise(async (resolve, reject) => {
        const chain = await uploadSignature()
        await chain
          .config({
            tip: false
          })
          .params({
            filename: [filename]
          })
          .onSuccess(async ([detail = {}]) => {
            const { policy, signature } = detail
            vm.others = {
              policy,
              signature
            }
            resolve(true)
          })
          .fetch()

        resolve(false)
      })
    },

    // 点击工具栏上传后又拍云的图片加密插入富文本
    async uploadChangeHandle (info) {
      const vm = this
      const { file } = info
      if (file.status === 'done') {
        const { response } = file
        const { url } = response
        if (url) {
          const chain2 = uploadConvert()
          await chain2
            .params({
              url
            })
            .onSuccess(payload => {
              // const ins = vm.$refs.myQuillEditor.quill
              // let length = ins.getSelection().index
              // let fileNameLength = file.name.length
              /* vm.addImgRange = ins.getSelection()
              ins.insertEmbed(
                ins.getSelection(),
                'image',
                payload
              )
              const index = (ins.getSelection() || {}).index || ins.getLength() - 1
              setTimeout(() => {
                ins.setSelection(index + 1)
              }, 0) */
              const ins = vm.$refs.myQuillEditor.quill
              const index = (ins.getSelection() || {}).index || ins.getLength() - 1
              ins.insertEmbed(index, 'image', payload)
              setTimeout(() => {
                ins.setSelection(index + 1)
              }, 0)

              this.imageLoading = false
            })
            .fetch()
        }
      } else if (info.file.status === 'error') {
        console.log('error')
      }
    },
    // 复制事件
    handlePaste (event) {
      this.pasteFiles = []
      const items = (event.clipboardData || window.clipboardData).items

      let file = null

      if (!items || items.length === 0) {
        this.$message.error(this.$t('message["163"]'))
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          event.preventDefault()

          this.imageLoading = true
          file = items[i].getAsFile()
          this.pasteFiles.push(file)
          this.pasteUpload(file)
        }
      }
    },

    // 复制图片/截图上传到又拍云
    pasteUpload (file) {
      if (!file) return
      let vm = this
      this.errorCount = 0
      this.successCount = 0

      if (file.size > 1024 * 1024 * 20) { // 支持20M以内的文件上传
        this.$message.error(this.$t('message["72"]'))
        this.errorCount++
      }

      axios.post(`${apiDomain}/upload/signature`, {
        'filename': [file.name || 'pasteImg.jpg'] // 文件本地路径
      }).then(res => {
        vm.uploadFile(file, res.data.payload)
      })
    },
    /*  文件上传 */
    fileUpload (url, params, res) {
      axios.post(url || `http://v0.api.upyun.com/westartrack-file`, params, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(data => {
        if (data.data.code === 200) {
          this.insertPasteImg(res[0].domain + res[0]._upt)

          this.successCount++
        } else {
          this.errorCount++
        }
        if (this.successCount + this.errorCount >= this.pasteFiles.length) {
          setTimeout(() => {
            if (this.errorCount) {
              this.$message.success(this.$t('message["991"]') + '，' + this.errorCount + '个文件由于过大上传失败。')
            } else {
              this.$message.success(this.$t('message["991"]'))
            }
          }, 100)
        }
      })
    },

    // 后端参数压缩上传
    async uploadFile (file, res) {
      let vm = this
      let url = res && res[0] && res[0].upyunurl

      // 构造FormData对象并赋值
      let formData = new FormData()
      formData.append('policy', res[0].policy) // 后端接口压缩图片参数
      formData.append('signature', res[0].signature)
      formData.append('file', file)
      vm.fileUpload(url, formData, res)
    },

    // 上传后的图片插入到富文本内
    async insertPasteImg (url) {
      let vm = this
      let newUrl = await this.$reSetFileUrl(url)
      const ins = vm.$refs.myQuillEditor.quill
      const index = (ins.getSelection() || {}).index || ins.getLength() - 1
      ins.insertEmbed(index, 'image', newUrl, 'user')
      setTimeout(() => {
        ins.setSelection(index + 1)
      }, 0)

      vm.imageLoading = false
    }
  }
}
</script>

<style lang="scss">
.quill-editor {
  a,
  abbr,
  acronym,
  address,
  applet,
  article,
  aside,
  audio,
  b,
  big,
  blockquote,
  body,
  canvas,
  caption,
  center,
  cite,
  code,
  dd,
  del,
  details,
  dfn,
  div,
  dl,
  dt,
  em,
  embed,
  fieldset,
  figcaption,
  figure,
  footer,
  form,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  header,
  html,
  i,
  iframe,
  img,
  input,
  ins,
  kbd,
  label,
  legend,
  li,
  mark,
  menu,
  nav,
  object,
  ol,
  output,
  p,
  pre,
  q,
  ruby,
  s,
  samp,
  section,
  small,
  span,
  strike,
  strong,
  sub,
  summary,
  sup,
  table,
  tbody,
  td,
  tfoot,
  th,
  thead,
  time,
  tr,
  tt,
  u,
  ul,
  var,
  video {
    font-weight: inherit;
  }
  strong {
    font-weight: bold;
  }
  .ant-form-explain {
    line-height: 40px;
  }
  .ql-toolbar.ql-snow {
    line-height: 1;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-color: #ebebeb;
  }

  .ql-container.ql-snow {
    height: 300px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-color: #ebebeb;
  }

  .ql-editor.ql-blank::before {
    color: #bfbfbf;
    font-style: normal;
  }
  .ql-snow .ql-tooltip {
    z-index: 99;
  }
  .ql-snow .ql-tooltip[data-mode='link']::before {
    content: '请输入链接地址:';
  }
  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: '保存';
    padding-right: 0px;
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='sans-serif']::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='sans-serif']::before {
    content: 'sans-serif';
    font-family: Arial, Helvetica, sans-serif;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='serif']::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {
    font-family: Georgia, Times New Roman, serif;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='monospace']::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {
    font-family: Monaco, Courier New, monospace;
  }
}

.ql-font-sans-serif {
  font-family: 'sans-serif';
}
.ql-font-sans-serif {
  font-family: 'sans-serif';
}
.ql-font-sans-serif {
  font-family: 'sans-serif';
}

.quill-editor-fullscreen .ql-container.ql-snow {
  height: calc(100% - 42px);
}
.ql-fullscreen {
  height: 24px;
  padding: 3px 5px;
  width: 28px;
  cursor: pointer;
  svg {
    width: 16px;
    height: 100%;
    path {
      fill: #444;
    }
    &:hover {
      path {
        fill: #06c;
      }
    }
  }
}
</style>
